<template>
    <div class="scoreTile">
        <div class="outer">
            <div class="inner">
                <div class="red">
                    <h2 :class="checkSmallFont">{{point}}</h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "scoreTile",
    computed: {},
    props: {
        point: {
            type: String,
            default: 0
        },
        smallFont: {
            type:Boolean,
            default:false
        }
    },
    computed: {
        checkSmallFont() {
            if(this.smallFont) {
                return "smallFont"
            }
        }
    }
};
</script>

<style scoped>
h2 {
    font-size: 7.5vh;
    color: #fff;
}
.smallFont {
    font-size:3vh;
}
.scoreTile {
    display: inline-block;
    position: relative;
    height: 100%;
    width: 30%;
    margin-left: 3%;
    border-radius: 2px;
    background: rgba(243, 244, 255, 1);
    background: -moz-linear-gradient(
        top,
        rgba(243, 244, 255, 1) 0%,
        rgba(234, 237, 247, 1) 54%,
        rgba(199, 210, 213, 1) 75%,
        rgba(170, 174, 174, 1) 100%
    );
    background: -webkit-gradient(
        left top,
        left bottom,
        color-stop(0%, rgba(243, 244, 255, 1)),
        color-stop(54%, rgba(234, 237, 247, 1)),
        color-stop(75%, rgba(199, 210, 213, 1)),
        color-stop(100%, rgba(170, 174, 174, 1))
    );
    background: -webkit-linear-gradient(
        top,
        rgba(243, 244, 255, 1) 0%,
        rgba(234, 237, 247, 1) 54%,
        rgba(199, 210, 213, 1) 75%,
        rgba(170, 174, 174, 1) 100%
    );
    background: -o-linear-gradient(
        top,
        rgba(243, 244, 255, 1) 0%,
        rgba(234, 237, 247, 1) 54%,
        rgba(199, 210, 213, 1) 75%,
        rgba(170, 174, 174, 1) 100%
    );
    background: -ms-linear-gradient(
        top,
        rgba(243, 244, 255, 1) 0%,
        rgba(234, 237, 247, 1) 54%,
        rgba(199, 210, 213, 1) 75%,
        rgba(170, 174, 174, 1) 100%
    );
    background: linear-gradient(
        to bottom,
        rgba(243, 244, 255, 1) 0%,
        rgba(234, 237, 247, 1) 54%,
        rgba(199, 210, 213, 1) 75%,
        rgba(170, 174, 174, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f3f4ff', endColorstr='#aaaeae', GradientType=0 );
}
.outer {
    position: absolute;
    z-index: 1;
    top: 10%;
    left: 5%;
    width: 88%;
    height: 78%;
    background: -webkit-gradient(
        left top,
        left bottom,
        color-stop(0%, rgba(170, 174, 174, 1)),
        color-stop(10%, rgba(150, 150, 150, 1)),
        color-stop(25%, rgba(199, 210, 213, 1)),
        color-stop(44%, rgba(170, 174, 174, 1)),
        color-stop(72%, rgba(234, 237, 247, 1)),
        color-stop(80%, rgba(199, 210, 213, 1)),
        color-stop(100%, rgba(234, 237, 247, 1))
    );
    background: -webkit-linear-gradient(
        top,
        rgba(170, 174, 174, 1) 0%,
        rgba(150, 150, 150, 1) 10%,
        rgba(199, 210, 213, 1) 25%,
        rgba(170, 174, 174, 1) 44%,
        rgba(234, 237, 247, 1) 72%,
        rgba(199, 210, 213, 1) 80%,
        rgba(234, 237, 247, 1) 100%
    );
    background: -o-linear-gradient(
        top,
        rgba(170, 174, 174, 1) 0%,
        rgba(150, 150, 150, 1) 10%,
        rgba(199, 210, 213, 1) 25%,
        rgba(170, 174, 174, 1) 44%,
        rgba(234, 237, 247, 1) 72%,
        rgba(199, 210, 213, 1) 80%,
        rgba(234, 237, 247, 1) 100%
    );
    background: -ms-linear-gradient(
        top,
        rgba(170, 174, 174, 1) 0%,
        rgba(150, 150, 150, 1) 10%,
        rgba(199, 210, 213, 1) 25%,
        rgba(170, 174, 174, 1) 44%,
        rgba(234, 237, 247, 1) 72%,
        rgba(199, 210, 213, 1) 80%,
        rgba(234, 237, 247, 1) 100%
    );
    background: linear-gradient(
        to bottom,
        rgba(170, 174, 174, 1) 0%,
        rgba(150, 150, 150, 1) 10%,
        rgba(199, 210, 213, 1) 25%,
        rgba(170, 174, 174, 1) 44%,
        rgba(234, 237, 247, 1) 72%,
        rgba(199, 210, 213, 1) 80%,
        rgba(234, 237, 247, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#aaaeae', endColorstr='#eaedf7', GradientType=0 );
}
.inner {
    position: absolute;
    z-index: 2;
    top: 5%;
    left: 6%;
    width: 89%;
    height: 90%;
    background: #5b0000;
}
.red {
    position: absolute;
    z-index: 3;
    left: 10%;
    width: 80%;
    top: 10%;
    height: 80%;
    /* background:#7C0303; */
    background: #7c0303;
}
</style>
